'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isThursday;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/isThursday.js
// module id = 246
// module chunks = 1